export default __webpack_public_path__ + "assets/images/0eff93ab73c73d6ec4628de6ccd15967.png";